import axios from 'axios'

export default {
    namespaced: true,
    state: {
        emaApplicationChecklistStatuses: [],
    },
    mutations: {
        SET_EMA_APPLICATION_CHECKLIST_STATUSES(state, payload) {
            state.emaApplicationChecklistStatuses = payload;
        },
    },
    actions: {
        async FetchEMAApplicationChecklistStatuses({ commit }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/ema/checklist/statuses/list`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) {
                            commit('SET_EMA_APPLICATION_CHECKLIST_STATUSES', response.data.payload);
                            resolve(response.data.message);
                        }
                        else reject(response.data.message);
                    }).catch(error => reject(`FetchEMAApplicationChecklistStatuses: ${error.message}`));
            });
        },
    },
    getters: {
        EMAApplicationChecklistStatuses(state) { return state.emaApplicationChecklistStatuses; },
    }
}
